import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

/**
 * Renders a single nav item row inside the mobile drawer. Splitting this out
 * keeps `MobileNav` slim and lets the parent stay focused on grouping/auth
 * concerns.
 */
const MobileNavItem = ({ item, pathname, user, isPro, onClose }) => {
  const authLocked = item.requiresAuth && !user;
  const proLocked = item.requiresPro && !isPro;
  const locked = authLocked || proLocked;
  const isActive = pathname === item.path;

  return (
    <Link
      to={item.path}
      className={`flex items-center justify-between px-3 py-2 rounded-md text-sm font-medium transition-colors ${
        isActive
          ? 'bg-white/10 text-cyan-300'
          : 'text-white/80 hover:bg-white/5 hover:text-white'
      }`}
      onClick={onClose}
      data-testid={`mnav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <span>{item.name}</span>
      <div className="flex items-center gap-1.5">
        {proLocked && (
          <span className="text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-violet-500/20 text-violet-300 border border-violet-400/30">
            Pro
          </span>
        )}
        {locked && <Lock className="w-3.5 h-3.5 text-white/40" />}
      </div>
    </Link>
  );
};

export default MobileNavItem;
